module.exports = __webpack_public_path__ + "static/media/cards-bank.33fe9629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shopping-cart/cards-bank.png
// module id = 2319
// module chunks = 0